<template>
    <section id="forgot-password">
        <b-modal @hide="onHide" id="forgot-password-modal" ref="forgotModalRef" centered hide-header hide-footer>
            <div class="forgot-password mx-auto d-flex justify-content-center align-items-center position-relative">
                <button
                        @click="$store.commit('TOGGLE_MODAL', ['forgot-pass', false])"
                        aria-label="Close"
                        id="modal-close"
                        class="close pr-2">
                            <CloseCross/>
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <p class="p3b c22">What’s your email?</p>
                        <p class="c23 p1n">Where do we send the reset link? Let us know. </p>
                    </div>
                    <EmailInput 
                        :on-submit="sendResetEmail"
                        :activ-fields="{email: true}"
                        :on-email-confirmed="onEmailConfirmed"/>
                    
                    <button 
                        :class="{'inactive': !email}"
                        @click="sendResetEmail" 
                        class="c16 p2b phiolet_button mt-2">
                            Reset Password
                    </button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import {mapState, mapGetters} from 'vuex'
    import EmailInput from '@/components/EmailPasswordValid/EmailInput.vue'
    import {GoogleIcon,CloseCross} from '../components/Icons'
    import { db, auth } from '../firebase';

    export default {
        name: 'forgot-password',
        components: {
            EmailInput,
            GoogleIcon,
            CloseCross
        },
        data() {
            return {
                email: '',
            }
        },
        computed: {
            ...mapState([
                'user',
                'message'
            ]),
            ...mapGetters(['usersCollection'])
        },
        mounted: function() {
            this.$bvModal.show(`forgot-password-modal`)
        },
        methods: {
            onHide: function(evt) {
                this.email = null;
                setTimeout(() => {
                    this.$store.commit('TOGGLE_MODAL', ['forgot-pass', false])
                }, 0);
                this.$store.dispatch('clearErrors');
            },
            sendResetEmail: function () {
                db
                    .collection(this.usersCollection)
                    .where('email','==', this.email)
                    .get()
                    .then(snapshot => {
                        if(snapshot.empty) {
                            return 
                        }
                        let emailAddress = this.email

                        auth.sendPasswordResetEmail(emailAddress).then(()=> {
                            // Email sent.
                            this.$store.commit('TOGGLE_MODAL', ['forgot-pass', false])
                            this.$store.commit('TOGGLE_MODAL', ['confirm-reg', true]);
                        }).catch((error) => {
                            // An error happened.
                            console.log(error)
                        });


                    })

                

            },
            onEmailConfirmed(val) {
                this.email = val;
            },
        }
    }

</script>

<style scoped lang="scss">
div.forgot-password {
    width: 450px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    @media screen and (max-width: 767px) {
        width: 100%
    }

    div.modal-container-wrap {
        width: 325px;
        padding-top: 40px;
        padding-bottom: 20px;

        @media screen and (max-width: 767px) {
            width: 73%
        }

        button {
            width: 100%;
            height: 48px;
            &:first-child {
                background: #F4F4F4;
                border-radius: 5px;
                transition: all 0.2s ease;

                &:hover {
                    box-shadow: 0px 4px 8px #858585;
                }
            }
            &.inactive {
                background: #F4F4F4 !important;
                color: #858585 !important;
                transition: all 0.2s ease;
                &:hover {
                    box-shadow: 0px 4px 8px #858585;
                }
            }
        }
    }
}

</style>
